import { createLucideIcon } from "lucide-react";

/**
 * Printer Orders icon: a t-shirt with an ink drop on the chest. Our printers
 * print onto garments, not paper (owner 2026-10-27). Lucide's Shirt plus a drop,
 * so it sizes and strokes like every other nav icon.
 */
export const ShirtPrint = createLucideIcon("ShirtPrint", [
  [
    "path",
    {
      d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
      key: "shirt",
    },
  ],
  ["path", { d: "M12 11.5c-1.3 1.6-2 2.7-2 3.6a2 2 0 0 0 4 0c0-.9-.7-2-2-3.6z", key: "drop" }],
]);
